import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Globe, Eye } from 'lucide-react';
import SubNav from './components/SubNav';
import ProjectPosition from './ProjectPosition';
import ProjectVisualAudit from './ProjectVisualAudit';

/**
 * Onglet fusionné « Visibilité IA » : positionnement GEO + audit visuel.
 */
export default function ProjectVisibiliteTab({ defaultSub = 'geo' }) {
  const [params, setParams] = useSearchParams();
  const sub = params.get('sub') || defaultSub;
  const setSub = (key) => {
    const next = new URLSearchParams(params);
    next.set('sub', key);
    setParams(next, { replace: true });
  };

  return (
    <div className="flex flex-col gap-4">
      <SubNav
        active={sub}
        onChange={setSub}
        items={[
          { key: 'geo', label: 'Positionnement IA', icon: Globe },
          { key: 'visual', label: 'Audit visuel', icon: Eye },
        ]}
      />
      {sub === 'visual' ? <ProjectVisualAudit /> : <ProjectPosition />}
    </div>
  );
}
